/* global HTMLIFrameElement */ /* global $ReadOnlyArray */ import { useEffect } from "react";
import "@cbook/shared/tinymce/plugins/codesample/prism";
import "@cbook/shared/tinymce/plugins/codesample/prism.css";
function highlightCode(iframe) {
    // enable prismjs code highlighting in either the preview iframe or the current body
    return new Promise(function(resolve) {
        setTimeout(function() {
            if (iframe && iframe.contentWindow) {
                window.Prism.highlightAllUnder(iframe.contentWindow.document.body);
            } else {
                window.Prism.highlightAll();
            }
            resolve();
        }, 0);
    });
}
function useCodeHighlight(iframe, inputs) {
    useEffect(function() {
        highlightCode(iframe);
    }, inputs);
}
export default highlightCode;
export { useCodeHighlight };
